import { createElement } from 'react'
import OptimizationSummaryChartOnly from '~/dashboard/azure_master_optimizations/optimization_summary_chart_only'
import ReactController from './react_controller'

export default class AzureMasterOptimizationsChartOnlyController extends ReactController {
  static values = {
    organizationId: String,
    masterOptimizationId: String,
  }

  createComponent() {
    return createElement(OptimizationSummaryChartOnly, {
      organizationId: this.organizationIdValue,
      masterOptimizationId: this.masterOptimizationIdValue,
    })
  }
}
